module.exports = __webpack_public_path__ + "img/app-logo.6d0da744.png";